import React from 'react';
import {
  Link,
  withRouter,
  ContextRouter,
} from 'react-router-dom';

import Tracker from '../../../../../components/Tracker';
import { WelcomeHeader } from '../../../../../components/WelcomeHeader';
import WagLoginForm from '../components/WagLoginForm';

import { SIGNUP_URL } from '../../../../../constants/urls';

import style from './WagLogin.module.css';

type Props = ContextRouter;

const WagLogin = ({
  location: {
    search,
  },
}: Props) => (
  <>
    <WelcomeHeader />
    <div className={style.loginContainer}>
      <div className={style.row}>
        <div className={style.column}>
          <h2 className={style.title}>
            Login
          </h2>
          <div>
            Sign in to access your Wag! account.
          </div>
          <div className={style.card}>
            <WagLoginForm />
            <Link
              data-testid="forgot-password-link"
              to="/forgot-password"
            >
              Forgot your password?
            </Link>
            <div className="mt-2">
              New user?
              {' '}
              <Link
                data-testid="signup-link"
                to={{
                  search,
                  pathname: SIGNUP_URL,
                }}
              >
                Sign up here.
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Tracker/>
  </>
);

const EnhancedWagLogin = withRouter<any>(WagLogin);

export {
  EnhancedWagLogin as WagLogin,
};
